<template>
  <div class="dropdown-container position-relative">
    <i class="bi bi-clock position-absolute dropdown-icon-left"></i>
    <select class="form-select form-select-sm dropdown-with-icon-left" v-model="selectedMode" @change="handleChange">
      <option value="only_regular_opening_hours" :disabled="disabledModes.includes('only_regular_opening_hours')">{{ $t('openingHours.mode.regular') }}</option>
      <option value="regular_and_irregular_opening_hours" :disabled="disabledModes.includes('regular_and_irregular_opening_hours')">{{ $t('openingHours.mode.regularIrregular') }}</option>
      <option value="all" :disabled="disabledModes.includes('all')">{{ $t('openingHours.mode.all') }}</option>
    </select>
  </div>
</template>

<script>
import { ref, watch } from 'vue'

export default {
  name: 'OpeningHoursModeSelector',
  
  props: {
    openingHoursMode: {
        type: String,
        default: 'only_regular_opening_hours',
    },
    disabledModes: {
      type: Array,
      default: () => [],
    }
  },
  
  emits: ['updateOpeningHoursMode'],
  
  setup(props, { emit }) {
    const selectedMode = ref(props.openingHoursMode)

    const handleChange = () => {
        emit('updateOpeningHoursMode', selectedMode.value)
    }

    watch(() => props.openingHoursMode, (newVal) => {
      selectedMode.value = newVal
    })

    return {
      selectedMode,
      handleChange,
    }
  }
}
</script>

<style scoped>
.dropdown-container {
  position: relative;
  width: 240px; /* Adjust width as needed */
  max-width: 100%; /* never exceed the (possibly narrow) container */
}

.form-select {
  color: #4F7EB3;
  padding: 5px 10px;
  border-radius: 4px;
}

.dropdown-with-icon-left {
  padding-left: 2.5rem; /* Add padding to make room for the icon */
}

.dropdown-icon-left {
  left: 10px; /* Position icon inside the select box on the left */
  top: 50%; /* Center vertically */
  transform: translateY(-50%);
  pointer-events: none; /* Prevent interaction with the icon */
  color: #425461; /* Adjust color if needed */
  font-size: 1rem; /* Adjust size if needed */
}
</style>